import { render, staticRenderFns } from "./largeCockpit.vue?vue&type=template&id=1686905f&scoped=true"
import script from "./largeCockpit.vue?vue&type=script&lang=js"
export * from "./largeCockpit.vue?vue&type=script&lang=js"
import style0 from "./largeCockpit.vue?vue&type=style&index=0&id=1686905f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1686905f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1686905f')) {
      api.createRecord('1686905f', component.options)
    } else {
      api.reload('1686905f', component.options)
    }
    module.hot.accept("./largeCockpit.vue?vue&type=template&id=1686905f&scoped=true", function () {
      api.rerender('1686905f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/largeCockpit.vue"
export default component.exports